module.exports = __webpack_public_path__ + "img/time.bb57224d.svg";